// This value is the same as the value set in validate.go in Requests
const MINIMUM_NOTICE_PERIOD_MINUTES = 140;

/**
 * Returns true if the appointment time is at least 140 minutes in the future.
 */
export function isAppointmentValid(time: string): boolean {
    const cutoff = new Date(Date.now() + MINIMUM_NOTICE_PERIOD_MINUTES * 60 * 1000);
    return new Date(time) > cutoff;
}
